import { render, staticRenderFns } from "./ArchivedWebpageList.vue?vue&type=template&id=8f11536a&scoped=true&"
import script from "./ArchivedWebpageList.vue?vue&type=script&lang=js&"
export * from "./ArchivedWebpageList.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedWebpageList.vue?vue&type=style&index=0&id=8f11536a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f11536a",
  null
  
)

export default component.exports